"use strict";

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuizzProvider = exports.QuizzContext = exports.ConfigContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reducer = _interopRequireDefault(require("./reducer"));

var _initialState = _interopRequireDefault(require("./initialState"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ConfigContext = (0, _react.createContext)();
exports.ConfigContext = ConfigContext;
var QuizzContext = (0, _react.createContext)();
exports.QuizzContext = QuizzContext;

var QuizzProvider = function QuizzProvider(props) {
  var typeViz = props.typeViz,
      showStepper = props.showStepper,
      hasLocalStorage = props.hasLocalStorage,
      children = props.children,
      data = props.data;

  var _useState = (0, _react.useState)({
    localStorage: hasLocalStorage === "true",
    stepper: showStepper === "true",
    questionnaire: data.questionnaire,
    parties: data.parties,
    defaultViz: typeViz || "speedometer",
    // speedometer or simple-bar
    defaultSegmentColors: [["#bf616a", "#a3be8c"], ["#bf616a", "#d08770", "#a3be8c"], ["#bf616a", "#d08770", "#ebcb8b", "#a3be8c"]]
  }),
      _useState2 = _slicedToArray(_useState, 2),
      config = _useState2[0],
      setConfig = _useState2[1];

  var localState = config.localStorage && typeof window !== "undefined" ? JSON.parse(localStorage.getItem("quizz")) : false;

  var _useReducer = (0, _react.useReducer)(_reducer["default"], localState || _initialState["default"]),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1]; // Synchronisation du localStorage en fonction de la config


  (0, _react.useEffect)(function () {
    if (typeof window !== "undefined") {
      if (config.localStorage) {
        localStorage && localStorage.setItem("quizz", JSON.stringify(state));
      } else {
        localStorage && localStorage.removeItem("quizz");
      }
    }
  }, [state, config.localStorage]);
  (0, _react.useEffect)(function () {
    // Resynchro du state
    // Si l'ID du questionnaire de la config est différent de celui du state 
    // et que le quizz est completed on reset de force et sans prévenir, dans 
    // tous les autres cas on affiche une invite pour lancer un reset
    if (state.currentQuestionnaireID !== "" && state.currentQuestionnaireID !== config.questionnaire.id) {
      state.completed ? dispatch({
        type: "RESET"
      }) : dispatch({
        type: "INVITE_RESET",
        value: true
      });
    } else {
      dispatch({
        type: "INVITE_RESET",
        value: false
      });
    }
  }, [state.completed, config.questionnaire.id, state.currentQuestionnaireID]);
  (0, _react.useEffect)(function () {
    // cette fonction pourrait sortir d'ici, c'est un utils ?
    // possible qu'un traitement en useCallBack comme en dessous serait pas mal ?
    // ou alors, on sort cette fonction dans utils, en la passant en stateless
    // et on la call depuis notre callBack du dessous qui retourne la totale du coup...
    // Et puisqu'on fait du dispatch ici, on en profite pour passer tout le reste
    // en state aussi et 
    if (state.results && state.results.length) {
      var accumulateur = 0;
      state.results.map(function (res) {
        var _config$questionnaire = config.questionnaire.questions.filter(function (q) {
          return q.id === res.question_id;
        }),
            _config$questionnaire2 = _slicedToArray(_config$questionnaire, 1),
            refQuest = _config$questionnaire2[0];

        if (refQuest && refQuest.choices && refQuest.choices.length) {
          if (refQuest.type === "bool") {
            // Traitement type bool / radio
            var _refQuest$choices$fil = refQuest.choices.filter(function (choice) {
              return choice.id === res.response_id;
            }),
                _refQuest$choices$fil2 = _slicedToArray(_refQuest$choices$fil, 1),
                resChoice = _refQuest$choices$fil2[0];

            if (resChoice) {
              // console.log(`question ${refQuest.id}, score: ${resChoice.score}`)
              accumulateur += resChoice.score;
              return resChoice;
            }
          } else {
            // Traitement type multi / checkboxes
            var _resChoice = refQuest.choices.filter(function (choice) {
              return res.response_id && res.response_id.length && res.response_id.indexOf(choice.id) !== -1;
            });

            if (_resChoice && _resChoice.length) {
              _resChoice.map(function (r) {
                // console.log(`question ${refQuest.id}, score: ${r.score}`)
                accumulateur += r.score;
                return r;
              });
            }
          }
        }

        return res;
      }); // console.log("global score:", accumulateur)

      dispatch({
        type: "UPDATE_GLOBAL_SCORE",
        value: accumulateur
      });
    }
  }, [state.results, config.questionnaire.questions]); // Memoisation du calcul des scores et du totalMax,
  // retourne un array
  // FIXME
  // on devrait passer ca en dispatch, ca simplifierait les choses ...
  // pourquoi ne veut-on pas garder ça dans le state ? y'avait une raison ?
  // - c'est pas parcequ'on l'appel différement entre le debug et le viewer que ca 
  // nous empecherait de dispatcher cette compute quand on en a besoin 
  // - on doit pouvoir merger avec le calcul + dispatch UPDATE_GLOBAL_SCORE, 
  // voir comments du useEffect au dessus
  // * les calculs pourraient tous sortir d'ici, propable ...

  var memoGetPartiesScoreArray = (0, _react.useCallback)(function () {
    var computed_scores = (0, _utils.get_parties_score)(config.questionnaire.questions, config.parties, state.results);
    var converted = [];
    var totalMax = 0;
    Object.entries(computed_scores).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      totalMax += value.max;
      converted.push(_objectSpread({
        key: key
      }, value));
    }); // console.log(
    //   "Score par Parties Array (from context)",
    //   computed_scores,
    //   converted
    // )

    return [converted, totalMax];
  }, [config.questionnaire.questions, config.parties, state.results]);
  var api = {
    memoGetPartiesScoreArray: memoGetPartiesScoreArray,
    getNext: function getNext() {
      var response_id = state.currentResult.response_id;
      var questions = config.questionnaire.questions;
      var _state$currentQuestio = state.currentQuestion,
          id = _state$currentQuestio.id,
          type = _state$currentQuestio.type,
          choices = _state$currentQuestio.choices;
      var choice;
      var prepaQuest;

      if (type === "bool" && response_id) {
        // récup de la value de goto présente dans le choice de la question
        choice = choices.filter(function (c) {
          return c.id === response_id;
        });

        if (choice && choice.length && choice[0]["goto"]) {
          prepaQuest = questions.filter(function (q) {
            return q.id === choice[0]["goto"];
          }); // console.log("la prochaine question", prepaQuest)
        } else {
          console.log("erreur, pas de goto ?");
        }
      }

      if (type === "multi" && response_id && response_id.length) {
        prepaQuest = questions.filter(function (q) {
          return q.id === id + 1;
        });
      }

      if (prepaQuest && prepaQuest.length) {
        // console.log(prepaQuest[0]);
        return prepaQuest[0];
      } else {
        console.log("erreur, pas de prepaQuest");
        return null;
      }
    }
  };
  return _react["default"].createElement(ConfigContext.Provider, {
    value: [config, setConfig]
  }, _react["default"].createElement(QuizzContext.Provider, {
    value: [state, dispatch, api]
  }, children));
};

exports.QuizzProvider = QuizzProvider;